import MessageBox from '@/components/common/message/messageBox'
import EchartsBorder from '@/components/echartsBorder/EchartsBorder.vue'
import EchartsLineBgc from '@/components/myEcharts/EchartsLineBgc.vue'
import EchartsPieColour from '@/components/myEcharts/EchartsPieColour.vue'
import EchartsPieOne from '@/components/myEcharts/EchartsPieOne.vue'
import TabList from '@/components/myElement/TabList.vue'
import ElementUi from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import waterproof from 'spt-waterproof'
import Vue from 'vue'
import App from './App.vue'
import './assets/css/reset.less'
import router from './router'
import store from './store'
//import 'default-passive-events' //解决新版谷歌浏览警告
// import '@/utils/rem.js'
// 全局js
//import '@/components/common/login/login' //全局初始化弹窗实例
import inputFilter from '@/directives/index'
import EchartsTextStyle from '@/minixs/EchartsTextStyle.js'
import global from './utils/global'; // 全局方法
Vue.mixin(EchartsTextStyle)
window.forceWebGL = true //全局强制启用webgl
Vue.use(global)
Vue.use(ElementUi)
Vue.use(waterproof)
Vue.use(inputFilter)
Vue.use(MessageBox);   //封装的messagebox组件 通过this调用
Vue.config.productionTip = false
Vue.component('echarts-border', EchartsBorder)
Vue.component('echarts-pie-one', EchartsPieOne)
Vue.component('echarts-pie-colour', EchartsPieColour)
Vue.component('echarts-line-bgc', EchartsLineBgc)
Vue.component('tab-list', TabList)
Vue.config.devtools = true
// Vue.prototype.$echartsResize = function (ref) {
//   window.addEventListener("resize", function () {
//     ref.resize()
//   })
// }
const myVue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.prototype.$myVue = myVue
